<template>
<tutorial-layout title="Custom Components" :referenceLinks="referenceLinks" :youtubeLinks="youtubeLinks">
    <p slot="overview">

        App builds typically have their own settings and configurations. This tutorial explains the best practices for
        implementing application settings for your environment.

        <br />

        <i>Please note that standard env files violate the traditional CI/CD separation of concerns since they require that the environment variables should be known at build time..
            This pattern ensures that variables can be altered during the delivery phase of deployment.
            As a result we highly discourage the use of .env files for storing environment variables and configs.</i>

    </p>
    <p slot="benefits">
        The primary benefit of this pattern is the ability use an access application level settings in any environment DEV/STG/PRD without having to know anything about those environments at build time.
        Additionally, this pattern will enable multiple applications to live side by side within this framework without creating variable name conflicts due to the use of app namespaces.
    </p>

    <h3>Part 1: Working with Settings and Variables</h3>
    <p>
        Every app folder should have an app.config containing all of custom settings and configurations for the application.
        One attribute in this file that we will try to understand a little bit better is the settings object.
        As a developer all of your app specific configuration should be set here (such as custom colors, api urls and more).
    </p>

    <p>
        Accessing these settings can be done relatively easily using the settings-mixin.js available in every project.
        This mixin adds a single computed property to your components called settings where you can access all of the sub attributes directly.
        So let us take the following example:
    </p>

    <p>
        In this case we have an attribute called favoriteColor with the value blue as seen in the code below.
    </p>
 
    <code>
        <pre>{{settings}}</pre>
    </code>

    Accessing this value is relatively simple.
    <ol>
        <li>
            First import the application settings mixin (app-mixin.js) and add it to your mixin array.
        </li>
        <code>
            import settingsMixin from "../mixins/app-mixin.js"<br />
            ...<br />
            mixins : [settingsMixin]<br />
            ...<br />
        </code>
        <li>
            Then you can reference the value using the settings computed that was added by the mixin.
        </li>
        <code>
            this.settings.favoriteColor<br />
            <br />
            output:<br />
            {{this.settings.favoriteColor}}
        </code>
    </ol>

    <h3>Part 2: Implementing Different Values per Environment</h3>
    <p>
        Ensure that that there are environment variables set in the application with keys that follow this pattern:

        <code>
            ui_{namespace}_{varName} = value
        </code>

        In this case we could change the value of the favoriteColor setting by implementing an environment variable on the app service that looks like this:

        <code>ui_uicoreTutorials_favoriteColor = "red"</code>
        <br />

        Notes:<br />
        *Look at the references section for information on how to modify the environment variables on a specific app service.<br />
        **It is not recommended to use the keyvault values in this manner since by nature the keyvault is a secret store and Javascript Clients are completely accessible from the browser.<br />

    </p>

    <!-- <pre>{{applicationConfig}}</pre> -->

</tutorial-layout>
</template>

<script>
import moment from "moment";

import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
import appMixin from "../../mixins/app-mixin"

export default {
    name: "VModel",
    mixins: [uiView, appMixin],
    created() {},
    data() {
        return {
            text1: "Example Text",
        };
    },
    components: {
        tutorialLayout
    },
    props: {},
    watch: {},
    computed: {
        referenceLinks() {
            return [
                // {
                //   title: "Data binding to custom components",
                //   href:
                //     "https://www.digitalocean.com/community/tutorials/vuejs-add-v-model-support",
                // },
            ];
        },
        youtubeLinks() {
            return [];
        },
    },
    methods: {},
};
</script>

<style lang="scss">
</style>
